var Latitude, Longitude;    
    // Tenta obter a localizacÃ£o do usuÃ¡rio pelo navegador,
    // Ã© o mÃ©todo mais preciso mas depende de aceitacÃ£o do usuÃ¡rio
    function obterLocalizacaoNavegador() {
        if (window.navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function sucesso(location) {               
                Latitude = location.coords.latitude;
                Longitude = location.coords.longitude;
                document.getElementById('Latitude').value  = Latitude;
                document.getElementById('Longitude').value = Longitude;
            }, function falha() {
                obterLocalizacaoPorIP(); 
            },
            {
                timeout: 10000
            }
            );
        } else {
            obterLocalizacaoPorIP();
        }
    }

    // Tenta obter uma localizacao pelo IP do dispositivo
    // utilizando a API em *geoplugin.net*
    function obterLocalizacaoPorIP() {
        var url = 'http://ip-api.com/json';
        $.get(url).then(function sucesso(response) {
            // Se atualiza nosso local se ele for undefined, ou seja, nenhum método
            // funcionou e estamos utilizando um local padrão
            Latitude  = parseFloat(response.lat);
            Longitude = parseFloat(response.lon);
            document.getElementById('Latitude').value  = Latitude;
            document.getElementById('Longitude').value = Longitude;
            
        }, function falha() {
            document.getElementById('Latitude').value   = 0;
            document.getElementById('Longitude').value  = 0;
        });
    }